module.exports = __webpack_public_path__ + "img/asicshome.17723b43.png";